import { lens3m3nj3zkwtu6r as lens } from '../lensing/abstracts.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens_0,
  lens26es9640ifscs as lens_1,
  get_state389x218zizu8a as get_state,
  beginUse146s8dwmfk72s as beginUse,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
  Listenable3m4zqvjcbvczy as Listenable,
} from './coreInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from './abstracts.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ElementClass;
function Element() {
  if (ElementClass === VOID) {
    class $ {
      constructor($outer, key) {
        this.fan_1 = $outer;
        this.dan_1 = key;
        var tmp = this;
        tmp.ean_1 = lens(this.fan_1, (it) => it.p3(this.dan_1));
      }
      tah(listener) {
        return this.ean_1.tah(listener);
      }
      gan(value) {
        if (value == null)
          this.fan_1.t3(this.dan_1);
        else
          this.fan_1.s3(this.dan_1, value);
      }
      mam(_set____db54di) {
        return this.gan((_set____db54di == null ? true : !(_set____db54di == null)) ? _set____db54di : THROW_CCE());
      }
      f2() {
        return this.ean_1.f2();
      }
      oam(thisRef, property) {
        return this.nam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      qam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.pam(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).cak = valueSet;
    protoOf($).gah = set;
    protoOf($).nam = getValue;
    protoOf($).pam = setValue;
    protoOf($).tak = lens_0;
    protoOf($).bak = lens_1;
    protoOf($).qah = get_state;
    protoOf($).iaj = beginUse;
    initMetadataForClass($, 'Element', VOID, VOID, [MutableReactiveValue()], [1]);
    ElementClass = $;
  }
  return ElementClass;
}
var ReactiveMutableMap$reactiveEntries$1Class;
function ReactiveMutableMap$reactiveEntries$1() {
  if (ReactiveMutableMap$reactiveEntries$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.nan_1 = this$0;
        this.man_1 = this$0;
      }
      f2() {
        return this.nan_1.ian_1.d2();
      }
      tah(listener) {
        return this.man_1.tah(listener);
      }
      iaj() {
        return this.man_1.iaj();
      }
    }
    protoOf($).qah = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [ReactiveValue(), Listenable()]);
    ReactiveMutableMap$reactiveEntries$1Class = $;
  }
  return ReactiveMutableMap$reactiveEntries$1Class;
}
var ReactiveMutableMap$reactiveKeys$1Class;
function ReactiveMutableMap$reactiveKeys$1() {
  if (ReactiveMutableMap$reactiveKeys$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.pan_1 = this$0;
        this.oan_1 = this$0;
      }
      f2() {
        return this.pan_1.ian_1.q3();
      }
      tah(listener) {
        return this.oan_1.tah(listener);
      }
      iaj() {
        return this.oan_1.iaj();
      }
    }
    protoOf($).qah = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [ReactiveValue(), Listenable()]);
    ReactiveMutableMap$reactiveKeys$1Class = $;
  }
  return ReactiveMutableMap$reactiveKeys$1Class;
}
var ReactiveMutableMap$reactiveValues$1Class;
function ReactiveMutableMap$reactiveValues$1() {
  if (ReactiveMutableMap$reactiveValues$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.ran_1 = this$0;
        this.qan_1 = this$0;
      }
      f2() {
        return this.ran_1.ian_1.r3();
      }
      tah(listener) {
        return this.qan_1.tah(listener);
      }
      iaj() {
        return this.qan_1.iaj();
      }
    }
    protoOf($).qah = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [ReactiveValue(), Listenable()]);
    ReactiveMutableMap$reactiveValues$1Class = $;
  }
  return ReactiveMutableMap$reactiveValues$1Class;
}
var ReactiveMutableMapClass;
function ReactiveMutableMap() {
  if (ReactiveMutableMapClass === VOID) {
    class $ extends BaseListenable() {
      static san(map) {
        var $this = this.sam();
        $this.ian_1 = map;
        var tmp = $this;
        tmp.jan_1 = new (ReactiveMutableMap$reactiveEntries$1())($this);
        var tmp_0 = $this;
        tmp_0.kan_1 = new (ReactiveMutableMap$reactiveKeys$1())($this);
        var tmp_1 = $this;
        tmp_1.lan_1 = new (ReactiveMutableMap$reactiveValues$1())($this);
        return $this;
      }
      static tan() {
        return this.san(HashMap().n8());
      }
      uan(value) {
        if (!equals(value, this.ian_1)) {
          this.ian_1.v3();
          this.ian_1.u3(value);
          this.kal();
        }
      }
      mam(_set____db54di) {
        return this.uan((!(_set____db54di == null) ? isInterface(_set____db54di, KtMap()) : false) ? _set____db54di : THROW_CCE());
      }
      f2() {
        return this.ian_1;
      }
      v3() {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableMap.signal' call
        this.ian_1.v3();
        // Inline function 'kotlin.also' call
        this.kal();
        return Unit_instance;
      }
      t3(key) {
        // Inline function 'kotlin.also' call
        var this_0 = this.ian_1.t3(key);
        if (!(this_0 == null)) {
          this.kal();
        }
        return this_0;
      }
      u3(from) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableMap.signal' call
        this.ian_1.u3(from);
        // Inline function 'kotlin.also' call
        this.kal();
        return Unit_instance;
      }
      s3(key, value) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableMap.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.ian_1.s3(key, value);
        this.kal();
        return this_0;
      }
      van(key) {
        return new (Element())(this, key);
      }
      q3() {
        return this.ian_1.q3();
      }
      r3() {
        return this.ian_1.r3();
      }
      d2() {
        return this.ian_1.d2();
      }
      i1() {
        return this.ian_1.i1();
      }
      n3(key) {
        return this.ian_1.n3(key);
      }
      p3(key) {
        return this.ian_1.p3(key);
      }
      p1() {
        return this.ian_1.p1();
      }
      oam(thisRef, property) {
        return this.nam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      qam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.pam(tmp, property, (!(value == null) ? isInterface(value, KtMap()) : false) ? value : THROW_CCE());
      }
    }
    protoOf($).cak = valueSet;
    protoOf($).gah = set;
    protoOf($).nam = getValue;
    protoOf($).pam = setValue;
    protoOf($).tak = lens_0;
    protoOf($).bak = lens_1;
    protoOf($).qah = get_state;
    initMetadataForClass($, 'ReactiveMutableMap', $.tan, VOID, [KtMutableMap(), MutableReactiveValue(), BaseListenable()], [1]);
    ReactiveMutableMapClass = $;
  }
  return ReactiveMutableMapClass;
}
//region block: exports
export {
  ReactiveMutableMap as ReactiveMutableMapw66yu1ss5v6o,
};
//endregion

//# sourceMappingURL=ReactiveMutableMap.mjs.map
